import { COOKIE_STRING, OLD_UI_URL, REDIRECT_MVC } from "./api/api-client";
import Cookies from "universal-cookie";

export async function User_Logout() {
  let cookies = new Cookies();
  cookies.remove(COOKIE_STRING);
  cookies.remove(COOKIE_STRING, {
    domain: "." + window.location.hostname,
    path: "/",
  });
  if (REDIRECT_MVC === "TRUE") {
    window.location.href = OLD_UI_URL + "home/logout";
  } else {
    const locationPath = window.location.pathname;
    if (locationPath !== "/login") {
      window.location.href = "/login";
    }
  }
}
